export default "__VITE_ASSET__eenmABfc__"